export default __webpack_public_path__ + "static/media/Jason_Lin.1a95ddea.jpg";